import { defineMessages } from 'react-intl';

export default defineMessages({
  app: {
    id: 'app.name',
    defaultMessage: 'React Application',
  },
  emptyform: {
    id: 'form.emptyform',
    defaultMessage: 'Form is Empty.',
  },
  emptyFormDesc: {
    id: 'form.emptyform.desc',
    defaultMessage: 'Please make sure form already full fill.',
  },
  invalidBiller: {
    id: 'form.invalid',
    defaultMessage: 'Biller Invalid!',
  },
  buttonChange: {
    id: 'form.button.change',
    defaultMessage: 'Change',
  },
  buttonConfirm: {
    id: 'form.button.confirm',
    defaultMessage: 'OK',
  },
  buttonBack: {
    id: 'btn.back',
    defaultMessage: 'Bakc',
  },
  buttonErrorMaybeLater: {
    id: 'form.error.button.maybeLater',
    defaultMessage: 'MAYBE LATER',
  },
  buttonErrorTopup: {
    id: 'form.error.button.topup',
    defaultMessage: 'TOP UP',
  },
  buttonErrorChangeMethod: {
    id: 'form.error.button.changeMethod',
    defaultMessage: 'CHANGE METHOD',
  },
  buttonErrorOk: {
    id: 'form.error.button.ok',
    defaultMessage: 'OK',
  },
  buttonClose: {
    id: 'btn.close',
    defaultMessage: 'CLOSE',
  },
  senderNameTitle: {
    id: 'form.modal.senderName.title',
    defaultMessage: 'To continue, please add the sender name',
  },
  senderNamePlaceholder: {
    id: 'form.modal.senderName.placeholder',
    defaultMessage: 'Type the Sender Name here',
  },
  senderNameAdd: {
    id: 'form.modal.senderName.add',
    defaultMessage: 'ADD',
  },
  upgradeKycTitle: {
    id: 'form.panel.upgradeKyc.title',
    defaultMessage: 'Upgrade to Premium',
  },
  upgradeKycDesc: {
    id: 'form.panel.upgradeKyc.desc',
    defaultMessage:
      'To pay using DANA Balance, you must have a DANA Premium account. Let’s upgrade now!',
  },
  upgradeKycBtnLater: {
    id: 'form.panel.upgradeKyc.button.later',
    defaultMessage: 'MAYBE LATER',
  },
  upgradeKycBtnUpgrade: {
    id: 'form.panel.upgradeKyc.button.upgrade',
    defaultMessage: 'UPGRADE',
  },
  tnc: {
    title: {
      id: 'tnc.modal.title',
      defaultMessage: 'Updates on Terms & Conditions',
    },
    desc: {
      id: 'tnc.modal.body',
      defaultMessage:
        'Please read the updated Terms & Conditions to continue your payment.',
    },
    btn: {
      id: 'btn.continue',
      defaultMessage: 'CONTINUE',
    },
  },
  errorMessage: {
    accountNotFound: {
      title: {
        id: 'errorMessage.form.accountNotFound.title',
        defaultMessage: 'Phone number not found',
      },
      desc: {
        id: 'errorMessage.form.accountNotFound.desc',
        defaultMessage:
          'Your phone number has not registered in this provider. Check your phone number and try again later.',
      },
    },
    billerInactive: {
      title: {
        id: 'errorMessage.form.billerInactive.title',
        defaultMessage: 'Wah, penyedia ini nggak aktif',
      },
      desc: {
        id: 'errorMessage.form.billerInactive.desc',
        defaultMessage:
          'Penyedia yang kamu pilih lagi nggak aktif. Silakan ganti penyedia atau coba lagi nanti.',
      },
    },
    default: {
      title: {
        id: 'errorMessage.form.default.title',
        defaultMessage: 'Something went wrong',
      },
      desc: {
        id: 'errorMessage.form.default.desc',
        defaultMessage:
          'Something went wrong with our system. Please try again later.',
      },
    },
    transferDestinationUnavailable: {
      title: {
        id: 'errorMessage.form.transferDestinationUnavailable.title',
        defaultMessage: 'Uh-oh, bill not found',
      },
      desc: {
        id: 'errorMessage.form.transferDestinationUnavailable.desc',
        defaultMessage:
          "We couldn't find your bill at the moment. Your bill might have been paid or already past due.",
      },
    },
    invalidAmount: {
      title: {
        id: 'errorMessage.form.invalidAmount.title',
        defaultMessage: 'Your bill amount is invalid',
      },
      desc: {
        id: 'errorMessage.form.invalidAmount.desc',
        defaultMessage:
          'The bill amount you entered is invalid. Make sure to enter the correct amount and please try again.',
      },
    },
    billAlreadyPaid: {
      title: {
        id: 'errorMessage.form.billAlreadyPaid.title',
        defaultMessage: 'Yay, your bill is paid!',
      },
      desc: {
        id: 'errorMessage.form.billAlreadyPaid.desc',
        defaultMessage: 'You currently have no ongoing bills.',
      },
    },
    billAlreadyExpired: {
      title: {
        id: 'errorMessage.form.billAlreadyExpired.title',
        defaultMessage: 'This bill has expired',
      },
      desc: {
        id: 'errorMessage.form.billAlreadyExpired.desc',
        defaultMessage:
          'This bill has expired. To continue your payment, please create a new order.',
      },
    },
    billerPaymentNofFound: {
      title: {
        id: 'errorMessage.form.billerPaymentNofFound.title',
        defaultMessage: 'Uh-oh, bill not found',
      },
      desc: {
        id: 'errorMessage.form.billerPaymentNofFound.desc',
        defaultMessage:
          "We couldn't find your bill at the moment. Your bill might have been paid or already past due.",
      },
    },
    channelUnableToProcess: {
      title: {
        id: 'errorMessage.form.channelUnableToProcess.title',
        defaultMessage: 'Something went wrong',
      },
      desc: {
        id: 'errorMessage.form.channelUnableToProcess.desc',
        defaultMessage:
          'Something went wrong while processing your bill. Please try again later.',
      },
    },
  },
  genesis: {
    title: {
      id: 'form.genesis.title',
      defaultMessage: 'React Application',
    },
    desc: {
      id: 'form.genesis.desc',
      defaultMessage: 'Form is Empty.',
    },
  },
});
